import React, { PropTypes } from 'react';
import ContentComponent from '../Content';
import FlatButton from 'material-ui/FlatButton';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';
import { Tabs, Tab } from 'material-ui/Tabs';
import { headerOneIconFactory } from '../Content/HeaderOne/icons/index';
import { HeaderOneEditForm } from '../Content/HeaderOne/HeaderOneEditForm';
import { factoryCmsContent } from '../../../api/club-cms/content'

class ClubCMSRoot extends React.Component {
  static propTypes = {
    club_id: PropTypes.string,
    settings: PropTypes.object,
    loading: PropTypes.bool,
    updateCmsEditor: PropTypes.func.isRequired,
    applyClub: PropTypes.func.isRequired
  };

  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  state = {
    selectedTabIndex: 0,
    movable: false,
    openSpeedDial: false,
    cmsEditorState: null
  };

  constructor() {
    super(...arguments);
    this.onChange = state => this._onChange(state);
  }

  componentWillMount() {
    let {
      params: { id },
      club_id
    } = this.props;
    //@ToDo Fix it some how;
    this.props.loadCMSEditor(id || club_id);
    this.style = this.getStyles();
  }
  componentWillUpdate(props){
    if(props.club && (this.props.club !== props.club)) {
      if(props.club.list.includes(props.club_id)) props.applyClub(props.club.items[props.club_id]);
    }
  }
  _changeTab(selectedTabIndex) {
    if (selectedTabIndex === -1) {
      this.showEditHeader(null);
    } else {
      this.setState({ selectedTabIndex });
    }
  }

  _onChange(cmsEditorState) {
    this.props.updateCmsEditor(cmsEditorState);
  }
/*
  _addHeaderOne(type) {
    let { cmsEditorState } = this.props;
    this._onChange(cmsEditorState.addHeaderContent(type));
    this._toggleSpeedDial();
  }
*/

  _updateHeaderOneLabel(headerOne, label) {
    let { cmsEditorState } = this.props;
    this._onChange(
      cmsEditorState.updateHeaderOne(headerOne, headerOne.setLabel(label)),
    );
  }

  _updateHeaderOne(headerOne, newHeaderOne) {
    let { cmsEditorState } = this.props;
    this._onChange(cmsEditorState.updateHeaderOne(headerOne, newHeaderOne));
  }

  _updateHeaderTwoLabel(headerTwo, label) {
    let { cmsEditorState } = this.props;
    this._onChange(cmsEditorState.updateHeaderTwo(headerTwo.setLabel(label)));
  }

  _addHeaderTwoContent(headerTwo, type) {
    let { cmsEditorState } = this.props;
    this._onChange(cmsEditorState.updateHeaderTwo(headerTwo.addChild(factoryCmsContent(type))));
  }

  _updateContent(content) {
    let { cmsEditorState } = this.props;
    this._onChange(cmsEditorState.updateContent(content));
  }

  _toggleSpeedDial() {
    let { openSpeedDial } = this.state;

    openSpeedDial = !openSpeedDial;

    this.setState({ openSpeedDial });
  }

  getStyles() {
    return {
      tabActionsButton: {
        fontSize: 12,
        textTransform: 'none'
      }
    };
  }

  showEditHeader(node) {
    this.setState({
      editNode: true,
      node
    });
  }

  hideEditHeader() {
    this.setState({
      editNode: false,
      node: null
    });
  }

  saveHeader(data) {
    const { node } = this.state;
    const { cmsEditorState } = this.props;
    if (node) {
      this._onChange(
        cmsEditorState.updateHeaderOne(
          node,
          node.setIcon(data.icon).setLabel(data.label),
        ),
      );
    } else {
      this.onChange(cmsEditorState.addHeaderOneRaw(data));
    }
    this.hideEditHeader();
  }

  removeHeader(node) {
    let { cmsEditorState } = this.props;
    this._onChange(cmsEditorState.removeHeaderOne(node));
  }

  move(oldIndex, direction) {
    let { cmsEditorState } = this.props;
    this._onChange(cmsEditorState.move(oldIndex, oldIndex + direction));
    this._changeTab(oldIndex + direction);
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    let { save, cmsEditorState, loading } = this.props;
    let { selectedTabIndex, editNode } = this.state;
    const selectedItem = cmsEditorState
      ? cmsEditorState.items.get(selectedTabIndex)
      : null;

    return loading ? (
      <LoadingSpinner show={true} />
    ) : (
      <div>
        {this.renderHeader()}

        {editNode ? this.renderEditNode() : null}
        {selectedItem ? this.renderNode(selectedItem, selectedTabIndex) : null}
      </div>
    );
  }

  renderEditNode() {
    const { node } = this.state;
    return (
      <HeaderOneEditForm
        initialValues={node ? { icon: node.icon, label: node.label } : {}}
        onSubmit={data => this.saveHeader(data)}
        onClose={() => this.hideEditHeader()}
      />
    );
  }

  renderHeader() {
    const { save, cmsEditorState, goBack } = this.props;
    let { selectedTabIndex } = this.state;

    let {
      palette: { labelColor }
    } = this.context.muiTheme;

    return (
      <LoggedAppBar
        title="About us"
        isStatic={true}
        childrenHeight={72}
        iconElementRight={
          <div>
            <FlatButton
              onClick={() => save(cmsEditorState)}
              secondary={true}
              label="Save"
              style={{color: 'white'}}
            />
            <FlatButton onClick={goBack} secondary={true} label="Cancel" style={{color: 'white'}}/>
          </div>
        }
      >
        <Tabs
          value={selectedTabIndex}
          // eslint-disable-next-line no-unused-vars
          onChange={(event, val) => this._changeTab(event)}
        >
          {cmsEditorState
            ? cmsEditorState.items.map((node, index) => (
                <Tab
                  key={index}
                  icon={React.createElement(
                    headerOneIconFactory(node.icon, { color: 'red' }),
                  )}
                  label={node.label}
                  value={index}
                  style={{ color: labelColor }}
                />
              ))
            : null}
          <Tab
            label="Add new tab"
            value={-1}
            // eslint-disable-next-line no-unused-vars
            onActive={event => this.showEditHeader(null)}
            style={{ color: labelColor }}
          />
        </Tabs>
      </LoggedAppBar>
    );
  }

  renderNode(node, index) {
    const { cmsEditorState } = this.props;

    return (
      <div>
        {this.renderNodeMenu(node, index)}

        <ContentComponent
          node={node}
          onChange={newNode => this._updateHeaderOne(node, newNode)}
          updateHeaderOneLabel={(headerOne, label) =>
            this._updateHeaderOneLabel(headerOne, label)
          }
          updateHeaderTwoLabel={(header, label) =>
            this._updateHeaderTwoLabel(header, label)
          }
          addHeaderTwoContent={(headerTwo, type) => this._addHeaderTwoContent(headerTwo, type)}
          onUpdateContent={content => this._updateContent(content)}
          removeHeaderOne={headerOne =>
            this._onChange(cmsEditorState.removeHeaderOne(headerOne))
          }
          removeHeaderTwo={header =>
            this._onChange(cmsEditorState.removeHeaderTwo(header))
          }
          removeContent={content =>
            this._onChange(cmsEditorState.removeContent(content))
          }
          moveItem={(itemDrag, itemDrop) =>
            this._onChange(cmsEditorState.moveItem(itemDrag, itemDrop))
          }
        />
      </div>
    );
  }

  renderNodeMenu(node, index) {
    const { tabActionsButton } = this.style;
    let { cmsEditorState } = this.props;

    return (
      <div style={{ textAlign: 'right' }}>
        <FlatButton
          label="Edit Tab"
          onClick={() => this.showEditHeader(node)}
          secondary={true}
          labelStyle={tabActionsButton}
        />
        {index > 0 ? (
          <FlatButton
            label="Move Left"
            onClick={() => this.move(index, -1)}
            secondary={true}
            labelStyle={tabActionsButton}
          />
        ) : null}
        {index < cmsEditorState.items.size - 1 ? (
          <FlatButton
            label="Move Right"
            onClick={() => this.move(index, 1)}
            secondary={true}
            labelStyle={tabActionsButton}
          />
        ) : null}
        <FlatButton
          label="Remove Tab"
          onClick={() => this.removeHeader(node)}
          secondary={true}
          labelStyle={tabActionsButton}
        />
      </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(ClubCMSRoot);



// WEBPACK FOOTER //
// ./src/components/ClubCMS/ClubCMSRoot/ClubCMSRoot.jsx